<template>
  <div
    class="calendar-note"
    :data-zoom="zoom"
    :style="'left: ' + position.left + '%; right: ' + position.right + '%;'">
    <div
      :data-date="noteData.date"
      class="calendar-note-item"
      :style="'background-color:' + noteData.notes[0].color + ';'">
      <i class="material-icons">edit_note</i>
      <sup
        v-if="noteData.notes.length > 1"
        class="calendar-note-item-counter">
        {{ noteData.notes.length }}
      </sup>

      <div :class="{
        'calendar-note-item-notes': true,
        'is-left-edge': zoom > 2 && position.left < edgeValue,
        'is-right-edge': zoom > 2 && position.right < edgeValue
      }">
        <div
          v-for="(noteItem, index) of noteData.notes"
          :key="'note-item-' + index"
          class="calendar-note-item-notes-item"
          :style="'background-color: ' + noteItem.color + '; color: ' + getContrastColor(noteItem.color) + ';'">
          <small class="calendar-note-item-notes-item-date">
            {{ noteItem.date }}
          </small>
          <span class="calendar-note-item-notes-item-toolbar">
            <i
              class="material-icons text-primary"
              @click="editNote(noteItem)">edit</i>
            <i
              class="material-icons text-danger"
              @click="deleteNote(noteItem)">delete</i>
          </span>
          <div
            v-pure-html="noteItem.note"
            class="calendar-note-item-notes-item-text"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'calendar-note',
  props: [
    'dateFrom',
    'dateTo',
    'noteData',
    'zoom'
  ],
  computed: {
    position () {
      let validFrom = new Date(this.noteData.date + ' 00:00:00');
      let validTo = new Date(this.noteData.date + ' 23:59:59');
      let rangeFrom = new Date(this.dateFrom);
      let rangeTo = new Date(this.dateTo);
      let left = 0;
      let right = 0;

      if (validFrom > rangeFrom) {
        let diff = validFrom - rangeFrom;
        left = (diff / (rangeTo - rangeFrom)) * 100;
      }

      if (validTo < rangeTo) {
        let diff = rangeTo - validTo;
        right = (diff / (rangeTo - rangeFrom)) * 100;
      }

      return {
        left,
        right,
        width: 100 - left - right
      };
    }
  },
  data () {
    return {
      edgeValue: 0
    };
  },
  mounted () {
    this.edgeValue = (180 / document.querySelector('.calendar-navigation-notes-area').offsetWidth) * 100;
    this.$bus.$on('window-size-changed', this.updateEdgeValue);
  },
  methods: {
    getContrastColor (hex) {
      if (!hex) {
        return '#000000';
      }

      hex = hex.replace('#', '');
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
      let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return brightness > 125 ? '#000000' : '#FFFFFF';
    },
    editNote (noteItem) {
      this.$bus.$emit('calendar-note-popup-show', noteItem);
    },
    deleteNote (noteItem) {
      Vue.swal({
        title: 'Do you want to remove this note?',
        html: '',
        icon: 'question',
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        buttonsStyling: true
      }).then((result) => {
        if (result.value) {
          FormUtils.submitInBackground({
            $http: this.$http,
            endpoint: '/notes/delete/' + parseInt(noteItem.id, 10),
            errorTitle: 'An error occurred',
            errorText: 'An error occurred during saving the note. Please try again',
            successAction: () => {
              Vue.swal({
                title: 'Success',
                html: 'Note has been removed',
                icon: 'success',
                confirmButtonText: 'OK',
                buttonsStyling: true,
                timer: 1000,
                timerProgressBar: true
              });

              this.$bus.$emit('calendar-notes-update');
            }
          });
        }
      });
    },
    updateEdgeValue () {
      this.edgeValue = (180 / document.querySelector('.calendar-navigation-notes-area').offsetWidth) * 100;
    }
  },
  beforeDestroy () {
    this.$bus.$off('window-size-changed', this.updateEdgeValue);
  }
}
</script>

<style lang="scss" scoped>
.calendar-note {
  cursor: pointer;
  height: 40px;
  position: absolute;
  top: 4px;

  &-item {
    align-items: center;
    display: flex;
    justify-content: center;

    & > .material-icons {
      color: #fff;
      font-size: 24px;
      opacity: .85;
      pointer-events: none;
      position: relative;
      top: 0;
    }
  }

  &-item-counter {
    align-items: center;
    background: #fff;
    box-shadow: 0 2px 2px rgba(0, 0, 0, .25);
    border-radius: 8px;
    color:#000;
    display: flex;
    font-size: 11px;
    font-weight: bold;
    height: 16px;
    left: 50%;
    line-height: 16px;
    justify-content: center;
    padding: 0 3px;
    pointer-events: none;
    position: absolute;
    top: -8px;
    transform: translateX(-50%);
    min-width: 16px;
    z-index: 10;
  }

  &[data-zoom="1"],
  &[data-zoom="2"],
  &[data-zoom="4"],
  &[data-zoom="7"],
  &[data-zoom="14"],
  &[data-zoom="30"] {
    .calendar-note-item {
      background: #333;
      border-radius: 5px;
      left: 50%;
      height: 32px;
      position: absolute;
      top: 4px;
      transform: translateX(-50%);
      width: 32px;
    }
  }

  &[data-zoom="60"] {
    .calendar-note-item {
      background: #333;
      left: 50%;
      height: 24px;
      position: absolute;
      top: 8px;
      transform: translateX(-50%);
      width: 24px;
    }
  }

  &-item:hover {
    .calendar-note-item-notes {
      display: block;
    }
  }

  .calendar-note-item-notes {
    display: none;
    left: -130px;
    max-height: calc(100vh - 180px);
    overflow: auto;
    padding: 5px;
    position: absolute;
    top: 32px;
    width: 300px;

    &.is-left-edge {
      left: 0;
    }

    &.is-right-edge {
      left: -270px;
    }

    &-item {
      background: #f0f0f0;
      border-radius: 5px;
      box-shadow: 0 3px 5px rgba(0, 0, 0, .125);
      margin-top: 20px;
      padding: 15px;
      position: relative;

      &-date {
        display: block;
        font-size: 10px;
        line-height: 1;
        margin-bottom: 5px;
      }

      &-toolbar {
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, .125);
        padding: 0 5px;
        position: absolute;
        right: 10px;
        top: 5px;

        .material-icons {
          font-size: 14px;

          &:first-child {
            margin-right: 5px;
          }
        }
      }

      &-text {
        font-size: 12px;
      }
    }
  }

  &[data-zoom="60"] {
    .calendar-note-item-notes {
      top: 24px;
    }
  }
}
</style>
